export default "__VITE_ASSET__CoyvQvu3__"